<template>
  <div class="cy-summary">
    <div style="max-width: 800px">
      <div>
        <div v-html="$t('summary.description')"></div>

        <div class="mb-3">
          <span
            v-t="
              'If there\'s anything else you\'d like to let us know, then please use the form below:'
            "
          />
        </div>
      </div>
    </div>

    <div class="mt-5" style="max-width: 800px">
      <base-textarea
        id="message"
        :error="$store.state.error.state('email')"
        :error-messages="$store.state.error.get('email')"
        prepend-icon="mdi-text"
        :label="$t('Your notes')"
        :hint="
          $t(
            'If there\'s anything else you\'d like to let us know, then please write your notes here.',
          )
        "
        outlined
        rows="2"
        persistent-hint
        :value="$store.state.message"
        @change="$store.dispatch('setMessage', $event)"
        hide-details="auto"
      />
    </div>

    <div id="summary">
      <SummaryTable />
    </div>

    <div class="my-5" v-if="hasErrors">
      <v-alert type="error" text max-width="800px">
        <p>
          <span v-t="'Some of the previous pages contain errors or missing required fields.'" />
        </p>
        <p><span v-t="'Please go back and correct the errors.'" /></p>

        <div v-for="step in steps" :key="step.component">
          <div v-if="$store.getters['stepHasErrors'](step.component)">
            <base-btn
              class="my-1"
              light
              outlined
              color="error"
              @click="$store.commit('SET', { step: step.component })"
            >
              <span v-t="step.title" class="black--text" />
              <v-icon right>mdi-chevron-up</v-icon>
            </base-btn>
          </div>
        </div>
      </v-alert>
    </div>

    <div style="max-width: 800px">
      <div class="ma-5" v-if="!hasErrors">
        <v-checkbox
          :disabled="$store.getters.isDisabled"
          v-model="confirmed"
          :label="
            $t(
              'I have double-checked everything and I understand that changing my mind afterwards could result in additional surcharges.',
            )
          "
        ></v-checkbox>

        <div :title="!confirmed ? $t('Please check the confirmation box above') : null">
          <base-btn
            :disabled="$store.getters.isDisabled || !confirmed"
            color="success"
            large
            @click="submit"
            :loading="$store.getters['isLoading']('confirm')"
          >
            <span v-if="!$store.state.confirmed_at" v-t="'I confirm my preferences'" />
            <div v-else>
              <v-icon left>mdi-check</v-icon>
              <span v-t="'Confirmed'" />
            </div>
          </base-btn>
        </div>

        <v-alert type="error" class="my-5" v-if="errorMessage">
          <div :v-if="(errorStatus + '').charAt(0) === '5'">
            {{ errorStatus }}
            <span
              v-t="
                'Sorry, a technical error has occurred. An error message has already been automatically forwarded to our developer. Error message:'
              "
            />
          </div>
          {{ errorMessage }}
        </v-alert>
      </div>
    </div>
  </div>
</template>

<script>
import { steps } from "@/components/stepper/stepper";

import SummaryTable from "../../SummaryTable";
import parseLaravelErrors from "@/actions/parseLaravelErrors";
export default {
  components: {
    SummaryTable,
  },
  mounted() {
    // this.$store.dispatch("checkValidity");
  },

  data() {
    return {
      steps,
      confirmed: false,
      errorMessage: null,
      laravelErrors: "",
      errorStatus: null,
    };
  },
  computed: {
    hasErrors() {
      return (
        this.$store.state.error.errors && Object.keys(this.$store.state.error.errors).length > 0
      );
    },
    confirmedAt() {
      return this.$store.state.confirmed_at;
    },
  },
  watch: {
    confirmedAt(confirmedAt) {
      this.confirmed = confirmedAt ? true : false;
    },
  },
  methods: {
    async submit() {
      this.$store.commit("START_LOADING", "confirm");
      try {
        const response = await this.axios.post("confirm", {
          email: this.$store.state.email,
          apartment_id: this.$store.state.apartment_id,
        });
        this.$store.commit("SET", { confirmed_at: response.data.confirmed_at });
        this.$router.push({ name: "Success", query: this.$route.query });
      } catch (error) {
        this.errorMessage = error.response.data.message;
        this.errorStatus = error.response.status;
        this.laravelErrors = parseLaravelErrors(
          error.response.data.errors,
          "<br class='mb-3'>",
          "",
        );
      } finally {
        setTimeout(() => {
          this.$store.commit("STOP_LOADING", "confirm");
        }, 200);
      }
    },
  },
};
</script>
